import { cookie, post, put } from "./base";
import axios from "axios";

export const uploadAIDubbingVideo = async (fileHandle, data) => {
  try {
    const formData = new FormData();

    // Append fields to FormData object

    formData.append("file", fileHandle); // Ensure data.file is the file object
    formData.append("target_lang", data.target_lang || "auto"); // Default to "auto" if target_lang is not provided
    formData.append(
      "drop_background_audio",
      data.drop_background_audio || "false"
    );
    formData.append("project_id", data.project_id);
    formData.append("user_id", data.user_id);
    formData.append("source_lang", data.source_lang || "auto"); // Default to "auto" for source_lang

    // Make the API request
    const response = await axios.post(
      `${process.env.REACT_APP_SERVER_API_URL}/elevenlabs/ai_dubbing/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-CSRFToken": cookie("csrftoken"),
        },
      }
    );

    return response;
  } catch (error) {
    console.log("Error while uploading AI dubbing video:", error);
    return error;
  }
};
